var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThankYou(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "534px",
    height: "446px",
    viewBox: "0 0 534 446",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "17") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.3---L---Already-uploaded-(InActive)",
    transform: "translate(-754.000000, -257.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: 17,
    transform: "translate(754.249000, 257.900000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M511.751,230.6 C511.751,290.279134 487.441335,344.074409 448.462045,382.739764 C410.32102,420.984843 357.510369,444.1 299.251,444.1 C241.410763,444.1 188.600112,420.564567 150.039955,382.739764 C111.060665,344.074409 86.751,290.279134 86.751,230.6 C86.751,112.502559 181.893998,17.1 299.251,17.1 C416.608002,17.1 511.751,112.922835 511.751,230.6 Z",
    id: "Path",
    fill: "#933751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.251,91.1 C503.914415,91.1 511.751,83.2463415 511.751,73.6 C511.751,63.9109756 503.914415,56.1 494.251,56.1 C484.583317,56.1 476.751,63.9109756 476.751,73.6 C476.751,83.2463415 484.583317,91.1 494.251,91.1 Z",
    id: "Path",
    fill: "#933751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.251,23.1 C527.600643,23.1 532.751,17.925 532.751,11.6 C532.751,5.23392857 527.600643,0.1 521.251,0.1 C514.89725,0.1 509.751,5.23392857 509.751,11.6 C509.751,17.925 514.89725,23.1 521.251,23.1 Z",
    id: "Path",
    fillOpacity: 0.242378715,
    fill: "#933751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.251,91.1 C99.6006429,91.1 104.751,85.925 104.751,79.6 C104.751,73.2339286 99.6006429,68.1 93.251,68.1 C86.89725,68.1 81.751,73.2339286 81.751,79.6 C81.751,85.925 86.89725,91.1 93.251,91.1 Z",
    id: "Path",
    fillOpacity: 0.242378715,
    fill: "#933751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.751,318.1 C34.8975385,318.1 44.751,308.242308 44.751,296.1 C44.751,283.957692 34.8975385,274.1 22.751,274.1 C10.6002308,274.1 0.751,283.957692 0.751,296.1 C0.751,308.242308 10.6002308,318.1 22.751,318.1 Z",
    id: "Path",
    fill: "#933751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.751,119.1 L451.751,382.79509 C413.408303,421.005685 360.318416,444.1 301.751,444.1 C243.604933,444.1 190.515045,420.585788 151.751,382.79509 L151.751,119.1 L451.751,119.1 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#933751",
    opacity: 0.5,
    points: "306.751 254.043224 247.802535 195.1 227.751 215.156776 286.703697 274.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#933751",
    opacity: 0.5,
    points: "354.891009 167.1 267.751 254.268103 287.610991 274.1 374.751 186.931897"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#933751",
    points: "376.751 309.1 223.751 309.1 223.751 328.1 376.751 328.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#933751",
    points: "376.751 353.1 223.751 353.1 223.751 372.1 376.751 372.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#933751",
    points: "339.751 395.1 260.751 395.1 260.751 414.1 339.751 414.1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankYou);
export default __webpack_public_path__ + "static/media/thank_you.0d292f364a65b6ddd44a75ae74512fe5.svg";
export { ForwardRef as ReactComponent };